import React, { useMemo } from 'react';
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import ComponentPageHeader from '../../../Common/PageHeader/ComponentPageHeader';
import ComponentTubeListTable from './Components';
import { RootState } from '../../../redux/rootState';
import { exportToExcelData } from '../../../Common/PageHeader/helper';

function ScreenTubeList() {
  const { TubeListData } = useSelector((state: RootState) => state.ListTubeReducer);

  const excelData = useMemo(() => TubeListData?.Data?.map((item) => {
    const transformedDataItems = {
      Description: item.Description,
      NwtOnly: item.NwtOnly ? 'Yes' : 'No',
    };
    return transformedDataItems;
  }), [TubeListData]);

  const downloadExcel = () => {
    exportToExcelData(
      {
        data: excelData,
      },
      'Tube_type_list',
    );
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <ComponentPageHeader subHeading="TUBE TYPE LIST" downloadExcel={downloadExcel} />
      </Grid>
      <div className="whiteSpace" />
      <Grid item xs={12} sm={12} md={12} className="dataTableCustomMargin">
        <ComponentTubeListTable />
      </Grid>
    </Grid>
  );
}

export default ScreenTubeList;
